import Divider from './divider.vue';

export default Divider;


// WEBPACK FOOTER //
// ./src/components/divider/index.js